import { Link, LinkProps } from 'react-router-dom'

type DisableableLinkProps = LinkProps & {
  disabled?: boolean
}

export const DisableableLink: React.FC<DisableableLinkProps> = ({
  to,
  className,
  disabled,
  children,
  ...rest
}) => {
  if (disabled) {
    return <span>{children}</span>
  }

  return (
    <Link
      to={to}
      className={className}
      // accessibility
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : undefined}
      {...rest}
    >
      {children}
    </Link>
  )
}
